/* eslint-disable no-underscore-dangle */

class Audioplayer {
	// ---------------------------------
	// ---------- CONSTRUCTOR ----------
	// ---------------------------------

	constructor(root) {
		this._root = root;
		this._elements = this._findElements();

		this._bindEventListeners();
		this._setUpdater();

		// setTimeout(() => {
		// 	this._play();
		// }, 100);
	}

	// -----------------------------
	// ---------- METHODS ----------
	// -----------------------------

	// находит и возвращает элементы блока
	_findElements() {
		const r = this._root;

		return {
			audio: r.querySelector('.audioplayer__audio'),
			play: r.querySelector('.audioplayer__play'),
			iconPlay: r.querySelector('.audioplayer__icon--play'),
			iconPause: r.querySelector('.audioplayer__icon--pause'),
			timeline: r.querySelector('.audioplayer__timeline'),
			pin: r.querySelector('.audioplayer__pin'),
			time: r.querySelector('.audioplayer__time'),
		};
	}

	// регистрирует обработчики событий
	_bindEventListeners() {
		const {
			play,
			timeline,
		} = this._elements;

		play.addEventListener('click', this._handlePlayClick.bind(this));
		timeline.addEventListener('click', this._handleTimelineClick.bind(this));
	}

	// ########################################################################
	_setUpdater() {
		const {
			audio,
			pin,
			time,
		} = this._elements;

		setInterval(() => {
			pin.style.left = `${audio.currentTime / audio.duration * 100}%`;
			time.textContent = Audioplayer._getTimeCodeFromNum(audio.currentTime);
		}, 500);
	}

	// ########################################################################
	_play() {
		const {
			audio,
			iconPlay,
			iconPause,
		} = this._elements;

		audio.play();

		if (!audio.paused) {
			iconPlay.classList.add('is-hidden');
			iconPause.classList.remove('is-hidden');
		}
	}

	// ########################################################################
	_pause() {
		const {
			audio,
			iconPlay,
			iconPause,
		} = this._elements;

		audio.pause();

		if (audio.paused) {
			iconPlay.classList.remove('is-hidden');
			iconPause.classList.add('is-hidden');
		}
	}

	// turn 128 seconds into 2:08
	static _getTimeCodeFromNum(num) {
		let seconds = parseInt(num, 10);
		let minutes = parseInt(seconds / 60, 10);

		seconds -= minutes * 60;
		const hours = parseInt(minutes / 60, 10);
		minutes -= hours * 60;

		if (hours === 0) {
			return `${minutes}:${String(seconds % 60).padStart(2, 0)}`;
		}

		return `${String(hours).padStart(2, 0)}:${minutes}:${String(seconds % 60).padStart(2, 0)}`;
	}

	// ------------------------------------
	// ---------- EVENT HANDLERS ----------
	// ------------------------------------

	_handlePlayClick() {
		if (this._elements.audio.paused) {
			this._play();
		} else {
			this._pause();
		}
	}

	_handleTimelineClick(event) {
		const {
			audio,
			timeline,
		} = this._elements;

		const width = window.getComputedStyle(timeline).width;
		const timeToSeek = event.offsetX / parseInt(width, 10) * audio.duration;

		audio.currentTime = timeToSeek;
	}
}

window.addEventListener('DOMContentLoaded', () => {
	// eslint-disable-next-line no-new
	new Audioplayer(document.querySelector('.audioplayer'));
});

